import { clearInputField, getQueryStringParameter } from '../../../helpers.js'

$(document).ready(() => {
  const $form = $('form#natural-profile-form');

  if ($form.length === 0 || getQueryStringParameter('id') !== 'financial_training') {
    return;
  }

  const $hasFinancialTraining        = $('#hasFinancialTraining input[type=radio]', $form);
  const $hasFinancialTrainingDetails = $('#hasFinancialTrainingDetails', $form);

  $hasFinancialTraining.each((_, inputElement) => {
    if(inputElement.checked && inputElement.value === 'true') {
      $hasFinancialTrainingDetails.removeClass('d-none');
    }
  });

  $hasFinancialTraining.on('click', (inputElement) => {
    if(inputElement.target.value === 'true') {
      $hasFinancialTrainingDetails.removeClass('d-none');
    } else {
      clearInputField(document.getElementById('users_profile_natural_has_financial_training_details'));
      $form.submit();
    }
  });
})
